<template>
  <div class="order-table-container small">
    <loading-overlay :isLoading="orderPageLoading" :loadingText="'Loading...'" />
    <b-tabs class="mb-2" align="center" v-model="tabIndex">
      <b-tab title="Customer">
        <div class="my-4 container mobile-p-0">
          <div v-if="userSalesRepPermissions.length > 2">
            <multiselect
              v-model="selectedSalesRep"
              :options="userSalesRepPermissions"
              :close-on-select="true"
              :clear-on-select="false"
              placeholder="Select a Sales Representative"
              select-label=""
              track-by="Id"
              :custom-label="customLabel"
              @input="handleSalesRepSelect"
              :searchable="true">
            </multiselect>
          </div>
          <div class="row d-flex align-items-stretch">
            <div :class="!sameAddress ? 'col-md-6 mb-3' : 'col-md-12'">
              <b-card class="my-2 px-0 h-100">
                <customer-form
                  :title="'Bill To'"
                  :showSameAddressCheckbox="true"
                  :sameAddress="sameAddress"
                  @handleShowBillingAddress="handleSameAddress"
                  :showShippingMethod="true"
                  :showPOnumber="true"
                  ref="customerBillToForm"
                  :customers="customers"
                  :isBillTo="true"
                  :showSalesRepresentative="_isCustomerAdminSite() || _isSalesRepSite(site.Name)"
                  :countries="countries"
                  :states="states"
                  @checkDuplicatePO="checkDuplicatePO"
                  :isPoDuplicated="isPoDuplicated"
                  :userSalesReps="userSalesReps"
                  :defaultSalesRepNumber="selectedSalesRep?.Id"
                  :showOrderContact="_isCustomerAdminSite()"
                  @customerSelected="handleBillToCustomerSelected"
                 />
              </b-card>
            </div>
            <div class="col-md-6 mb-3" v-show="!sameAddress">
              <b-card class="my-2 px-0 h-100">
                <customer-form
                  :title="'Ship To'"
                  ref="customerShipToForm"
                  :customers="customerShipTos"
                  :countries="countries"
                  :states="states"
                  :isBillTo="false" />
              </b-card>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Items">
        <div class="my-4">
          <b-row style="text-align: center;" v-if="_isCustomerAdminSite()">
            <div class="col-md-4">
              <div class="row">
                <label for="shipping-method-dropdown" class="col-md-4">Storage Location:</label>
                <select
                  id="shipping-method-dropdown"
                  class="form-control col-md-8"
                  v-model="storageLocation"
                >
                  <option
                    v-for="method in storageLocations"
                    :key="method"
                    :value="method"
                  >
                    {{ method }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <label for="shipping-method-dropdown" class="col-md-4">Expected Shipping Date:</label>
                <b-input-group size="text-sm" class="col-md-8">
                  <b-input-group-prepend>
                    <b-form-datepicker
                      v-model.trim="expectedShippingDate"
                      button-only
                      size="sm"
                      locale="en-US"
                      button-variant="link"
                      :min="minExpectedShippingDate"
                      @input="userExpectedShippingDateUpdated"
                    ></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.trim="expectedShippingDate"
                    type="text"
                    size="sm"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    debounce="1000"
                    @change="userExpectedShippingDateUpdated"
                  ></b-form-input>
                </b-input-group>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-3">Incoterms:</label>
                <div class="col-md-9">
                  <div class="form-group row">
                    <div class="col-md-6 mr-0 pr-0">
                      <b-form-select v-model="inco1">
                        <b-form-select-option
                          :value="null"
                        >
                          Select Any
                        </b-form-select-option>
                        <b-form-select-option
                          :value="'Best Way'"
                        >
                          Best Way
                        </b-form-select-option>
                        <b-form-select-option
                          v-for="method in incoTerms"
                          :options="incoTerms"
                          value-field="Inco1"
                          text-field="Inco1"
                          :key="method.Inco1"
                          :value="method.Inco1"
                        >
                          {{ method.Inco1 }} - {{ method.Description }}
                        </b-form-select-option>
                    </b-form-select>
                    </div>
                    <div class="col-md-6 m-0 p-0" v-show="inco1 !== 'Best Way'">
                        <b-form-input
                          v-model="inco2"
                          type="text"
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-row>
          <cart-items :showSuggestedPrice="true" @handleBrowse="onBrowse" :displayCustomerMaterialColumn="true" :customerNumber="currentCustomer" />
          <product-finder
            :findingModel="showModelFinder"
            @close="closeModelFinder"
            :isUsedByOrdersSite="true"
            :showTopologyTabOnly="true"></product-finder>
        </div>
      </b-tab>
      <b-tab title="Shipping and Documents">
        <div class="my-4 container">
          <order-comments-form ref="customerComments"
            @onCommentsChange="onCommentsChange"
            :incoTerms="inco1and2"
            :orderItemNotes="orderItemNotes"
          />
        </div>
      </b-tab>
    </b-tabs>
    <div class="container">
      <div class="my-4 row">
        <div class="col-sm-12 col-md-6 my-2">
          <b-button
            block
            variant="outline-primary"
            class="color-primary border-primary"
            @click="updateNext(-1)"
            :disabled="tabIndex <= 0 || isSubmittingOrder || isCheckingPO">
            Back
          </b-button>
        </div>
        <div class="col-sm-12 col-md-6 my-2">
          <b-button
            block
            variant="primary"
            class="background-color-primary"
            @click="updateNext(+1)"
            :disabled="tabIndex == 3 || isSubmittingOrder || isCheckingPO">
            <template v-if="isSubmittingOrder">
              <loading loadingText="Submitting"></loading>
            </template>
            <template v-else>
              {{ tabIndex == 2 ? 'Place Order' : 'Next' }}
            </template>
          </b-button>
        </div>
      </div>
    </div>

    <b-modal v-model="confirmPlaceOrder" size="md" @ok="placeOrder" dialog-class="float-md-center" ok-title="Yes" cancel-title="No">
      <template #modal-header>
        Place Order
      </template>
      <span>Please confirm you wish to place this order and there is a PO Document attached</span>
    </b-modal>

  </div>
</template>
<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator'
import OrderCommentsForm from './order-comments.vue'
// TODO: MxOrders?
import CartItems from '@/components/cart/cart-items.vue'
import CustomerForm from '@/components/orders/new-order/customer-form.vue'
import ProductFinder from '@/components/modals/product-model-finder.vue'
import Loading from '@/components/utility/loading.vue'
import MxSite from '@/mixins/site'
import { Cart, CartItem } from '@/store/cart/types'
import {
  blankCustomer,
  blankOrderCustomer,
  blankOrderParty,
} from '@/store/orders/constants'
import { INewOrder, INewOrderItem, IOrderCustomer } from '@/store/orders/types'
import LoadingOverlay from '@/components/utility/loading-overlay.vue'
import Vue from 'vue'
import { namespace } from 'vuex-class'
import Multiselect from 'vue-multiselect'
import { ResourcePermission, ResourceType } from '@/store/security/types'
import { Api } from '@/api/Api'
import { isCustomerAdminSite } from '@/helpers/sites.helper'
import { IInquiry, IInquiryItem } from '../../../store/inquiry/types'
import { blankCartItem } from '@/store/cart/constants'
import { Model } from '@/store/editor/types'
import { ISalesRepresentative } from '@/store/sales-reps/types'
import dayjs from 'dayjs'
import businessDays from 'business-days-js'

const api = new Api()

const ORDER_CUSTOMER_TAB = 0
const ORDER_ITEMS_TAB = 1
const ORDER_VALIDATED = 2

const nsCart = namespace('cart')
const nsOrder = namespace('orders')
const nsOrderState = namespace('order-state')
const nsInquiry = namespace('inquiries')
const nsSearch = namespace('search')
const nsMultiplier = namespace('multiplier')
const nsCustomer = namespace('customer')
const nsUsers = namespace('users')
const nsCommon = namespace('common')

@Component({
  components: {
    CustomerForm,
    CartItems,
    OrderCommentsForm,
    ProductFinder,
    Loading,
    Multiselect,
    LoadingOverlay,
  },
})
export default class extends Mixins(MxSite) {
  private api = new Api()

  @nsCart.Action('saveCartItem')
  private saveCartItem: any

  @nsCart.Getter('cart')
  public cart!: Cart

  @nsCommon.Getter('storageLocations')
  private storageLocations: any

  @nsCommon.Action('fetchStorageLocations')
  private fetchStorageLocations: any

  @nsCommon.Getter('incoTerms')
  private incoTerms: any

  @nsOrder.Getter('currentCustomer')
  public currentCustomer!: Cart

  @nsCommon.Action('fetchIncoTerms')
  private fetchIncoTerms: any

  @nsOrder.Action('addOrder')
  private addOrder: any

  @nsOrder.State('activeOrder')
  private activeOrder: any

  @nsCustomer.State('activeCustomer')
  private activeCustomer: any

  @nsOrder.State('isSubmittingOrder')
  public isSubmittingOrder!: boolean

  @nsOrderState.State('customerShipTos')
  public customerShipTos!: IOrderCustomer[]

  @nsOrder.State('submissionError')
  private submissionError!: string

  @nsOrderState.Action('resetOrder')
  private resetOrder: any

  @nsInquiry.Action('fetchDocuments')
  private fetchDocuments: any

  @nsInquiry.State('inquiryDocuments')
  private inquiryDocuments: any

  @nsMultiplier.Getter('getMultiplierPrice')
  private getMultiplierPrice: any

  public userSalesRepPermissions: any = []
  public orderPageLoading = true
  public isPoDuplicated = false
  public isCheckingPO = false

  public userExpectedShippingDate = this.formatDate(dayjs(new Date()))
  public minExpectedShippingDate = this.formatDate(dayjs(new Date()).add(-1, 'day'))
  public expectedShippingDate = this.formatDate(dayjs(new Date()))
  public storageLocation = '9900'
  public inco1: any = null
  public inco2 = ''
  public orderItemNotes: string[] = []

  @nsSearch.Action('getVisibleModelsByPcn')
  private getVisibleModelsByPcn: any

  @nsUsers.Action('getUserSalesRep')
  public getUserSalesRep: any

  @Watch('activeOrder')
  public handleOrderAdded(newOrder) {
    if (newOrder.SalesOrderNumber) {
      this.$router.push({
        name: 'order_summary',
        params: { invoiceNo: newOrder.SalesOrderNumber },
      })
    }
  }

  public handleBillToCustomerSelected(billTo: any) {
    this.orderItemNotes = [...billTo.customerShippingText]
  }

  @Watch('submissionError')
  public alertSubmissionError(newError) {
    if (newError) {
      this.toastError(newError)
    }
  }

  public sameAddress = false
  public tabIndex = 0
  public customerShipToFormRef
  public customerBillToFormRef
  public customerCommentsFormRef
  public activeInquiry
  public confirmPlaceOrder = false

  public comments: string[] = []

  public showModelFinder = false
  public customerShipTo = blankOrderCustomer
  public customerBillTo = blankOrderCustomer
  public customers: IOrderCustomer[] = []
  public submitting = false
  public countries = []
  public states = []
  public selectedSalesRep: ResourcePermission | null = null
  public userSalesReps : ISalesRepresentative[] = []

  public handleSameAddress(checked: boolean) {
    this.sameAddress = checked
  }

  public async mounted() {
    // TODO jm
    if (isCustomerAdminSite(this.role) && this.userSalesRepPermissions.length <= 0) {
      this.api.fetchV2({ url: '/sales-rep?includePendingPermissions=false&includeUsers=false&pageSize=10000&page=1' })
        .then((salesRepsList) => {
          this.userSalesRepPermissions = [{ ResourceName: 'Select a Sales Representative', Id: null }, ...salesRepsList.List.map((item: any) => { return { Id: item.Id, ResourceName: item.Name } })]
          this.setOverlayShowing(true)
          this.initializeComponents().then(() => {
            this.setOverlayShowing(false)
          })
        })
    } else {
      const permissions = (this.currentUser.ResourcePermissions ?? []).filter(item => item.Type === ResourceType.SalesRep).map((item: any) => { return { Id: item.ResourceId, ResourceName: item.ResourceName } })
      this.userSalesRepPermissions = [{ ResourceName: 'Select a Sales Representative', Id: null }, ...permissions]
      this.setOverlayShowing(true)
      this.initializeComponents().then(() => {
        this.setOverlayShowing(false)
      })
    }

    if (this._isCustomerAdminSite()) {
      this.fetchStorageLocations()
      this.fetchIncoTerms()
    }
  }

  @Watch('cart.items', { deep: true })
  public itemsUpdated(newArr: CartItem[]) {
    if (this._isCustomerAdminSite()) {
      const customerMaterialNotes = newArr.map((s, i) => { return { index: i, ...s } }).filter(s => s.customerMaterial && s.customerMaterial.length > 35).map(s => 'Line item ' + ((s.index + 1) * 10) + ': ' + s.customerMaterial!)
      // Filter out old customer material notes, then add new ones to front
      const filteredNotes = this.orderItemNotes.filter(note => !note.startsWith('Line item '))
      this.orderItemNotes = [
        ...customerMaterialNotes,
        ...filteredNotes,
      ]
      const leadTime = Math.max(...(newArr.filter(s => !Number(s.inventory))).map(s => s.leadTime || 0), 0)
      const bDays = businessDays({ state: 'tn' })
      const startDate = dayjs(new Date()).add(-1, 'day') // we do this because businessDays.addDays always starts from tomorrow
      this.minExpectedShippingDate = this.formatDate(bDays.addDays(startDate, leadTime))
      this.expectedShippingDate = this.minExpectedShippingDate
      if (dayjs(this.userExpectedShippingDate) > dayjs(this.expectedShippingDate)) {
        this.expectedShippingDate = this.userExpectedShippingDate
      }
    }
  }

  public userExpectedShippingDateUpdated(newValue: any) {
    if (dayjs(newValue) > dayjs(this.minExpectedShippingDate)) {
      this.userExpectedShippingDate = newValue
    }
  }

  public get inco1and2() {
    if (this.inco1 === 'Best Way') {
      return this.inco1
    } else if (this.inco1 && this.inco2) {
      return this.inco1 + ' ' + this.inco2
    }
    return null
  }

  public async initializeComponents() {
    this.resetOrder()

    this.customerShipToFormRef = this.$refs.customerShipToForm as Vue
    this.customerBillToFormRef = this.$refs.customerBillToForm as Vue
    this.customerCommentsFormRef = this.$refs.customerComments as Vue

    await this.fetchCustomers()
    await this.fetchCountries()
    await this.fetchUSStates()
    await this.fetchUserSalesReps()

    if (!this.$route.params.fromInquiry) {
      this.resetOrder()
    } else {
      const inquiry = this.$store.getters['inquiries/activeInquiry']
      this.activeInquiry = inquiry
      await this.setInquiry(this.activeInquiry)
    }
    this.orderPageLoading = false
  }

  public onCommentsChange(comments) {
    Vue.set(this, 'comments', comments)
  }

  public async setInquiry(inquiry: IInquiry) {
    if (!inquiry) {
      return
    }

    const customerBillTo = {
      ...blankCustomer,
      ...this.customerBillToFormRef.customers.find(c => c.customerNo === inquiry.CustomerNumber),
      address: {
        Name: inquiry.BillToParty.Name,
        Address1: inquiry.BillToParty.Address1,
        Address2: inquiry.BillToParty.Address2,
        City: inquiry.BillToParty.City,
        State: inquiry.BillToParty.State,
        Zip: inquiry.BillToParty.Zip,
        Phone: inquiry.BillToParty.Phone,
        Country: inquiry.BillToParty.Country,
        Email: inquiry.BillToParty.Email,
        FirstName: inquiry.BillToParty.FirstName,
        LastName: inquiry.BillToParty.LastName,
      },
    }
    const customerShipTo = {
      ...blankCustomer,
      address: {
        Name: inquiry.ShipToParty.Name,
        Address1: inquiry.ShipToParty.Address1,
        Address2: inquiry.ShipToParty.Address2,
        City: inquiry.ShipToParty.City,
        State: inquiry.ShipToParty.State,
        Zip: inquiry.ShipToParty.Zip,
        Phone: inquiry.ShipToParty.Phone,
        Country: inquiry.ShipToParty.Country,
        Email: inquiry.ShipToParty.Email,
        FirstName: inquiry.ShipToParty.FirstName,
        LastName: inquiry.ShipToParty.LastName,
      },
    }
    this.customerCommentsFormRef.populateComments(inquiry.Comments, inquiry.Contact, inquiry.JobName)
    this.customerShipToFormRef.customer = customerShipTo
    this.customerShipToFormRef.selectedCountry = customerShipTo.address.Country
    await this.customerShipToFormRef.handleCustomerSelect(customerShipTo)
    this.customerBillToFormRef.selectedDBCustomer = customerBillTo
    await this.customerBillToFormRef.handleCustomerSelect(this.customerBillToFormRef.selectedDBCustomer)
    await this.fetchDocuments(inquiry.InquiryId).then(() => this.customerCommentsFormRef.populateFiles(this.inquiryDocuments))

    const modelItems = await this.getVisibleModelsByPcn(inquiry.Items.map(x => x.MaterialNumber))
    await inquiry.Items.forEach(async (inquiryItem: IInquiryItem) => {
      const model: Model = modelItems.List.filter((x: Model) => inquiryItem.MaterialNumber === x.PcnCatalogNumber)[0]
      const inquiryCharacteristics = inquiryItem.CharacteristicValues ?? []
      const subItems = inquiryItem.SubItems ?? []
      let price = 0
      if (model.Configurable) {
        price = inquiryItem.Price
      } else {
        price = this.getMultiplierPrice(
          model.PcnCatalogNumber,
          model.ProductHierarchy,
          model.TotalList,
        )
      }
      const cartItem: CartItem = {
        pcnCatalogNumber: model.PcnCatalogNumber || '',
        SapModelDescription: model.SapModelDescription || '',
        fingoodTpiMfgMod: model.FingoodTpiMfgMod || '',
        description:
          model?.Descriptions[0]?.toString() || model.SapModelDescription || '',
        quantity: inquiryItem.Quantity,
        price: price || 0,
        totalPrice: (price || 0) * inquiryItem.Quantity,
        imgThumbnail: model.Image?.ImagePath || '',
        shippingStrategyId: model.ShippingStrategyId || 0,
        originalPrice: model.TotalList || 0,
        productHierarchy: model.ProductHierarchy || '',
        inventory: model.Available || '',
        modelDetails: model.Details,
        leadTime: model.LeadTime,
        characteristics: inquiryCharacteristics,
        configurable: model.Configurable,
        configured: model.Configurable,
        subItems: subItems!,
        priceLocked: inquiry.Status === 'Approved',
      }
      await this.saveCartItem({ cartItem })
    })
  }

  public async handleSalesRepSelect() {
    this.fetchCustomers()
  }

  async fetchCustomers() {
    // Make the API call to fetch customers based on the search keyword
    try {
      this.orderPageLoading = true
      await this.$store.dispatch('order-state/fetchCustomers', { keyword: '', salesRepId: this.selectedSalesRep?.Id })
      this.customers = this.$store.getters['order-state/customers']
    } catch (error) {
      console.error('Error fetching customers:', error)
    }
    this.orderPageLoading = false
  }

  async fetchCountries() {
    try {
      await this.$store.dispatch('common/fetchCountries', '')
      this.countries = this.$store.getters['common/countries']
    } catch (error) {
      console.error('Error fetching countries:', error)
    }
  }

  async fetchUSStates() {
    try {
      await this.$store.dispatch('common/fetchCountryStates', 'US') // get states for US for now
      this.states = this.$store.getters['common/countryStates']
    } catch (error) {
      console.error('Error fetching country states:', error)
    }
  }

  async fetchUserSalesReps() {
    try {
      if (this._isSalesRepSite(this.site.Name)) {
        await this.getUserSalesRep({ salesRepIds: [] }).then((salesReps: any) => {
          this.userSalesReps = [...salesReps.map((item: ISalesRepresentative) => { return { Id: item.Id, Name: item.Name } })]
        })
      }
    } catch (error) {
      console.error('Error fetching user sales rep:', error)
    }
  }

  public updateNext(mod: number) {
    // Check if user is trying to go forward
    if (mod === 1) {
      // If the current step is customer verification
      if (this.tabIndex === ORDER_CUSTOMER_TAB) {
        // Verify customer
        if (!this.verifyCustomer()) {
          // If verification fails, cannot proceed
          return
        }
        // Move to next step
        this.tabIndex = ORDER_ITEMS_TAB
      } else if (this.tabIndex === ORDER_ITEMS_TAB) {
        if (!this.verifyItems()) {
          return
        }
        this.tabIndex = ORDER_VALIDATED
      } else if (this.tabIndex === ORDER_VALIDATED) {
        if (!this.verifyOrder()) {
          return
        }

        if (!this.customerCommentsFormRef.verifyPODocumentSelected()) {
          return
        }

        this.confirmPlaceOrder = true // Open Modal confirmation
      }
    } else if (mod === -1) {
      // Decrementing the step index to move backward
      this.tabIndex -= 1
    }
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })
  }

  private verifyItems(): boolean {
    // Check if items are present in the cart
    if (this.cart.items.length === 0) {
      // If no items, cannot proceed
      this.toastWarning('Order must include one or more items')
      return false
    }
    const unconfigured = this.cart.items.filter(s => s.configurable && !s.configured)
    if (unconfigured.length > 0) {
      this.toastWarning('Configurable materials must be completed')
      return false
    }
    return true
  }

  public verifyOrder() {
    if (!this.verifyCustomer()) {
      this.tabIndex = ORDER_CUSTOMER_TAB
      return false
    }
    if (!this.verifyItems()) {
      this.tabIndex = ORDER_ITEMS_TAB
      return false
    }

    return true
  }

  public placeOrder() {
    const files = this.customerCommentsFormRef.validate().files
    const inquiryFiles = this.customerCommentsFormRef.validate().inquiryFiles
    const comments = this.comments

    // TODO: how to validate - also, do we need it for comments?
    // this.customerCommentsFormRef
    //   .validate().comments
    //   .filter((x) => x.value !== '')
    //   .map((x) => x.value)
    let itemNumber = 1
    const newOrder: INewOrder = {
      PurchaseNo: this.customerBillTo.poNumber,
      BillToParty: {
        ...blankOrderParty,
        PartnerNumber: this.customerBillTo.customerNo,
        Street: this.customerBillTo.address.Address1,
        Name2: this.customerBillTo.address.Address2,
        City: this.customerBillTo.address.City,
        Region: this.customerBillTo.address.State,
        PostalCode: this.customerBillTo.address.Zip,
        Country: this.customerBillTo.address.Country,
        Phone: this.customerBillTo.address.Phone,
        Name: this.customerBillTo.address.Name || '',
      },
      ShipToParty: {
        ...blankOrderParty,
        PartnerNumber:
          this.customerShipTo.customerNo || this.customerBillTo.customerNo,
        Street: this.customerShipTo.address.Address1,
        Name2: this.customerShipTo.address.Address2,
        City: this.customerShipTo.address.City,
        Region: this.customerShipTo.address.State,
        PostalCode: this.customerShipTo.address.Zip,
        Country: this.customerShipTo.address.Country,
        Phone: this.customerShipTo.address.Phone,
        Name:
          this.customerShipTo.companyName || this.customerShipTo.address.Name,
      },
      Items: this.cart.items.map((item) => {
        const orderItem: INewOrderItem = {
          Material: item.pcnCatalogNumber,
          ItemNumber: '',
          Quantity: item.quantity,
          QuantityUnit: 'EA',
          CustomerMaterialNumber: item.customerMaterial,
          CharacteristicValues: item.characteristics,
          SubItems: item.subItems?.map(i => { return { ...i, ItemNumber: this.itemNumberText(itemNumber++) } }),
        }
        if (this._isCustomerAdminSite()) {
          orderItem.ExpectedShippingDate = this.expectedShippingDate
          orderItem.StorageLocation = this.storageLocation
        }
        orderItem.ItemNumber += (orderItem.SubItems && orderItem.SubItems.length > 0) ? orderItem.SubItems[0]!.ItemNumber : this.itemNumberText(itemNumber++)
        return orderItem
      }),
      TextLines: comments,
      InquiryId: this.activeInquiry?.InquiryId,
      InquiryFiles: inquiryFiles?.map((file: any) => file.Id) || [],
      Files: files,
      SalesRepNumber: this.customerBillToFormRef.getSelectedSalesRepNumber(),
      OrderContact: this.customerBillToFormRef.getSelectedOrderContactEmail(),
    }
    if (this._isCustomerAdminSite()) {
      newOrder.ExpectedShippingDate = this.expectedShippingDate
      newOrder.StorageLocation = this.storageLocation
      newOrder.Inco1 = this.inco1
      newOrder.Inco2 = this.inco2
    }
    this.addOrder(newOrder)
  }

  public itemNumberText(number: number) {
    return (number * 10 + '').padStart(6, '0')
  }

  public verifyCustomer() {
    this.customerBillTo = {
      ...blankCustomer,
      ...this.customerBillToFormRef.validate(),
    }
    if (!this.sameAddress) {
      this.customerShipTo = {
        ...blankCustomer,
        ...this.customerShipToFormRef.validate(),
      }
    } else {
      this.customerShipTo = {
        ...blankCustomer,
        ...this.customerBillToFormRef.validate(),
      }
    }

    if (
      (this.customerShipTo.customerNo !== '' ||
        this.customerShipTo.address.Name !== '') &&
      this.customerBillTo.customerNo !== '' &&
      this.customerBillTo.poNumber !== ''
    ) {
      return true
    }

    return false
  }

  public onBrowse() {
    this.showModelFinder = true
  }

  public closeModelFinder() {
    this.showModelFinder = false
  }

  public async addBlankItem() {
    this.saveCartItem({ cartItem: { ...blankCartItem } })
      .catch(() => {
        this.toastError('Fail to add item to Order')
      })
  }

  public customLabel({
    Id,
    ResourceName,
  }: {
    Id: string
    ResourceName: string
  }) {
    return Id ? `${ResourceName} - ${Id}` : ResourceName
  }

  public _isCustomerAdminSite() {
    return isCustomerAdminSite(this.role)
  }

  public async checkDuplicatePO(poNumber: string) {
    this.isCheckingPO = true
    const url = `/order/PO/isDuplicated?poNumber=${poNumber}`
    api
      .fetch({
        url,
      })
      .then((response) => {
        this.isPoDuplicated = response.isPoDuplicated
        this.isCheckingPO = false
      })
  }

  public formatDate(date: any) {
    return dayjs(date).format('YYYY-MM-DD')
  }

  private validateDate(date: string): boolean {
    return dayjs(date, 'YYYY-MM-DD', true).isValid()
  }
}
</script>

<style>
.non-clickable-tab {
  pointer-events: none;
  cursor: default;
  /* Additional styling as needed */
}
</style>
